import {ExportLanguage, SkillRating} from './export-payload.model';

/**
 * NP20-958: Der Generator erwartet die Bewertung je Fähigkeit als eigene Stufe im Payload.
 * Quelle ist ausschliesslich das am Profil gepflegte Level — im Export wird nicht neu bewertet.
 */
const LEVEL_TO_RATING: Record<string, SkillRating> = {
  BASIS: 'BASIS',
  GUT: 'GOOD',
  SEHR_GUT: 'VERY_GOOD',
  EXZELLENT: 'EXCELLENT',
};

export function toSkillRating(level: string | null | undefined): SkillRating | null {
  if (!level) return null;
  return LEVEL_TO_RATING[level.trim().toUpperCase()] ?? null;
}

export function isRatedLevel(level: string | null | undefined): boolean {
  return toSkillRating(level) !== null;
}

/**
 * Traegt die Auswahl mindestens eine unbewertete Fähigkeit? Der Generator rendert die
 * Skill-Matrix aus dem Profil-Level; eine ausgewaehlte, aber unbewertete Fähigkeit stuende
 * dort leer. Hinweis (Kachel) und Sperre (Parent) lesen deshalb dieselbe Regel.
 */
export function hasUnratedSkills(
  skills: readonly {id?: string; level?: string}[] | null | undefined,
  selectedIds: readonly string[],
): boolean {
  const selected = new Set(selectedIds);
  return (skills ?? []).some(s => s.id !== undefined && selected.has(s.id) && !isRatedLevel(s.level));
}

/** Nimmt die Schreibweise des Backends ('DE'/'EN') zurueck in den internen Code. */
export function normalizeExportLanguage(value: string | null | undefined): ExportLanguage | null {
  const code = value?.trim().toLowerCase();
  return code === 'de' || code === 'en' ? code : null;
}

/**
 * Vorbelegung der Dokumentsprache: die Sprache der Oberflaeche, sonst Deutsch (NP20-1113).
 *
 * Bewusst eine reine Funktion ueber dem Sprachcode und nicht ueber dem `TranslateService` —
 * sie wird vom Exportbereich des Profils *und* vom Sprachdialog der Beraterliste gebraucht,
 * und beide sollen dieselbe Vorbelegung zeigen. Gelesen wird nur der Anfang des Codes, damit
 * auch `en-GB` als Englisch zaehlt.
 */
export function resolveDefaultExportLanguage(language: string | null | undefined): ExportLanguage {
  return (language ?? '').trim().toLowerCase().startsWith('en') ? 'en' : 'de';
}
